import React, { useEffect, useState } from "react";
import { motion, useAnimation } from "framer-motion";
import { FiPlay, FiPause } from "react-icons/fi";

const AartiThali = ({ animate }) => {
  const controls = useAnimation();

  const isMobile = window.innerWidth <= 768;
  const radius = isMobile ? 120 : 180;
  const duration = 4;

  const circularPath = {
    x: Array.from(
      { length: 101 },
      (_, i) => radius * Math.cos((i / 100) * 2 * Math.PI)
    ),
    y: Array.from(
      { length: 101 },
      (_, i) => radius * Math.sin((i / 100) * 2 * Math.PI)
    ),
  };

  useEffect(() => {
    if (animate) {
      controls.start({
        x: circularPath.x,
        y: circularPath.y,
        transition: {
          duration: duration,
          repeat: Infinity,
          ease: "linear",
        },
      });
    } else {
      controls.stop();
    }
  }, [animate]);

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 10000,
      }}
    >
      {/* Aarti Thali Circular Motion */}
      <motion.div
        animate={controls}
        style={{
          position: "absolute",
          marginTop: isMobile ? "150px" : "230px",
        }}
      >
        <img
          src="/aarti-thali.png"
          alt="Aarti Thali"
          style={{
            width: isMobile ? "100px" : "150px",
            height: isMobile ? "100px" : "150px",
          }}
        />

        {animate && (
          <motion.div
            animate={{
              boxShadow: [
                "0px 0px 40px rgba(255, 165, 0, 0.8)",
                "0px 0px 60px rgba(255, 69, 0, 1)",
                "0px 0px 40px rgba(255, 165, 0, 0.8)",
              ],
            }}
            transition={{
              duration: 1.5,
              repeat: Infinity,
              ease: "easeInOut",
            }}
            style={{
              position: "absolute",
              top: "-20px",
              left: "50%",
              transform: "translateX(-50%)",
              width: isMobile ? "40px" : "60px",
              height: isMobile ? "40px" : "60px",
              borderRadius: "50%",
              filter: "blur(8px)",
            }}
          />
        )}
      </motion.div>

      {/* Floating Action Button */}
      {/* <button
        onClick={startAnimation}
        style={{
          position: "absolute",
          bottom: "20px",
          padding: "10px 20px",
          backgroundColor: "#ff9800",
          border: "none",
          color: "white",
          fontSize: "16px",
          borderRadius: "5px",
          cursor: "pointer",
        }}
      >
        {animate ? "Stop Aarti" : "Start Aarti"}
      </button> */}
    </div>
  );
};

export default AartiThali;
